import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeCheckboxField from '@s-ui/react-molecule-checkbox-field'
import CheckboxUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import CheckboxChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'

const BASE_CLASS = 'mt-CardAd-footer'

const CardAdComparator = ({ad, enableComparator, handleSelectComparar, comparatorSelectedAds = []}) => {
  const {i18n} = useContext(Context)

  const isComparatorSelected = useMemo(() => {
    return enableComparator && comparatorSelectedAds?.some(selectedAd => Number(selectedAd.id) === Number(ad.id))
  }, [ad.id, comparatorSelectedAds, enableComparator])

  const handleComparator = e => {
    e.stopPropagation()

    handleSelectComparar(ad)
  }

  const label = isComparatorSelected ? i18n.t('COMPARATOR.AD_CARD_COMPARING') : i18n.t('COMPARATOR.AD_CARD_COMPARE')

  return (
    <MoleculeCheckboxField
      checked={isComparatorSelected}
      checkedIcon={CheckboxChecked}
      uncheckedIcon={CheckboxUnchecked}
      id={`comparator_${ad.id}`}
      onChange={handleComparator}
      nodeLabel={<span className={`${BASE_CLASS}-comparatorCheckboxLabel`}>{label}</span>}
      aria-label={label}
    />
  )
}

CardAdComparator.displayName = 'CardAdComparator'

CardAdComparator.propTypes = {
  ad: PropTypes.object.isRequired,
  comparatorSelectedAds: PropTypes.array,
  enableComparator: PropTypes.bool,
  handleSelectComparar: PropTypes.func
}

export default memo(CardAdComparator)
